Wee.fn.make('fittext', {
	init: function() {
		if ($('ref:resizeText').length > 0) {
			var $el = $('ref:resizeText'),
				fontSize = $el.parent().width() / (8 * 10);

			$el.css('font-size', fontSize + 'rem');

			this.timer();
		}
	},

	timer: function() {
		$(Wee._win).on('resize', function() {
			clearTimeout(this.throttler);

			this.throttler = setTimeout(this.init(), 500);
		}.bind(this));
	}
});